(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[402],{

/***/ 59622:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ GlyphsCharacter_GlyphsCharacter; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.0.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(43010);
// EXTERNAL MODULE: ./node_modules/.pnpm/clsx@1.1.1/node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(51626);
// EXTERNAL MODULE: ./components/global/GlyphsCharacter/GlyphsCharacter.module.scss
var GlyphsCharacter_module = __webpack_require__(86654);
var GlyphsCharacter_module_default = /*#__PURE__*/__webpack_require__.n(GlyphsCharacter_module);
;// CONCATENATED MODULE: ./components/global/GlyphsCharacter/GlyphsCharacter.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}



var GlyphsCharacter = function(param) {
    var char = param.char, entity = param.entity, script = param.script, subCategory = param.subCategory, glyphSheetName = param.glyphSheetName, handler = param.handler, _as = param.as, as = _as === void 0 ? "div" : _as, style = param.style, _hoverEffect = param.hoverEffect, hoverEffect = _hoverEffect === void 0 ? true : _hoverEffect, children = param.children;
    var glyphContent = /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (GlyphsCharacter_module_default()).glyphChar__Entity,
                children: entity
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (GlyphsCharacter_module_default()).glyphChar__Char,
                style: style ? style : {
                    fontFamily: "var(--".concat(glyphSheetName, ")"),
                    color: "var(--black)"
                },
                children: children || char
            })
        ]
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,clsx_m/* default */.Z)((GlyphsCharacter_module_default()).glyphChar, _defineProperty({}, (GlyphsCharacter_module_default()).hoverEffect, hoverEffect)),
        children: as === "div" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: glyphContent
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
            type: "button",
            title: "Open Glyph Modal for further detail",
            onClick: function() {
                return handler(char, script, subCategory);
            },
            children: glyphContent
        })
    });
};
/* harmony default export */ var GlyphsCharacter_GlyphsCharacter = (GlyphsCharacter);

;// CONCATENATED MODULE: ./components/global/GlyphsCharacter/index.ts



/***/ }),

/***/ 10402:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "g": function() { return /* reexport */ PanelGlyphs_PanelGlyphs; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.1.4_yscj52izot5zgtrz33zielpism/node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(6666);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.0.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(43010);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.0.0/node_modules/react/index.js
var react = __webpack_require__(85170);
// EXTERNAL MODULE: ./components/global/GlyphsCharacter/index.ts + 1 modules
var GlyphsCharacter = __webpack_require__(59622);
// EXTERNAL MODULE: ./components/global/Modal/index.tsx + 1 modules
var Modal = __webpack_require__(96332);
// EXTERNAL MODULE: ./components/global/Panel/index.ts
var Panel = __webpack_require__(12490);
// EXTERNAL MODULE: ./components/global/Panel/PanelContent.tsx
var PanelContent = __webpack_require__(74819);
// EXTERNAL MODULE: ./components/global/Panel/PanelHeader.tsx
var PanelHeader = __webpack_require__(21252);
// EXTERNAL MODULE: ./components/Spinner.tsx
var Spinner = __webpack_require__(90625);
// EXTERNAL MODULE: ./lib/util.tsx + 1 modules
var util = __webpack_require__(70108);
// EXTERNAL MODULE: ./components/global/PanelFont/PanelGlyphs/PanelGlyphs.module.scss
var PanelGlyphs_module = __webpack_require__(2245);
var PanelGlyphs_module_default = /*#__PURE__*/__webpack_require__.n(PanelGlyphs_module);
;// CONCATENATED MODULE: ./components/global/PanelFont/PanelGlyphs/GlyphModalContent.tsx





var hexToDecimal = function(charDecimal) {
    return parseInt(charDecimal, 16);
};
var htmlEntity = function(string) {
    return "&#x".concat(string, ";");
};
var htmlCode = function(charDecimal) {
    return "&#".concat(parseInt(charDecimal, 16), ";");
};
var getCssVariableValue = function(variable) {
    return getComputedStyle(document.documentElement).getPropertyValue(variable);
};
// Opentype.js function that fixes the canvas scaling on mobile devices https://github.com/opentypejs/opentype.js/blob/1c0c01982f9855cb5ceff64c9465af1be5cf8876/glyph-inspector.html#L76-L89
var enableHighDPICanvas = function(canvas, pixelRatio) {
    if (!canvas || pixelRatio === 1) return;
    var canvasClass = canvas.classList;
    if (canvasClass.length === 1) {
        var oldWidth = canvas === null || canvas === void 0 ? void 0 : canvas.width;
        var oldHeight = canvas === null || canvas === void 0 ? void 0 : canvas.height;
        canvas.width = oldWidth * pixelRatio;
        canvas.height = oldHeight * pixelRatio;
        canvas.getContext("2d").scale(pixelRatio, pixelRatio);
        canvas.classList.add("high-dpi"); // Add this class flag so we'll just run this function once
    }
};
var dashline = function(ctx, ctxWidth, yunits) {
    ctx.strokeStyle = getCssVariableValue("--grey-primary");
    ctx.beginPath();
    ctx.setLineDash([
        4,
        4
    ]);
    ctx.moveTo(0, yunits);
    ctx.lineTo(ctxWidth, yunits);
    ctx.stroke();
};
var hline = function(ctx, ctxWidth) {
    return function(yunits, param) {
        var _text = param.text, text = _text === void 0 ? "" : _text, _top = param.top, top = _top === void 0 ? true : _top, _dashed = param.dashed, dashed = _dashed === void 0 ? false : _dashed;
        var textYunits = top ? yunits - 5 : yunits + 20;
        ctx.fillText(text, 0, textYunits);
        return dashed ? dashline(ctx, ctxWidth, yunits) : ctx.fillRect(0, yunits, ctxWidth, 1.5);
    };
};
// For drawing the Glyph on canvas https://github.com/opentypejs/opentype.js/blob/1c0c01982f9855cb5ceff64c9465af1be5cf8876/glyph-inspector.html#L194-L237
var drawGlyphPath = function(ctx, path) {
    var i, cmd, x1, y1, x2, y2;
    ctx.beginPath();
    for(i = 0; i < path.commands.length; i += 1){
        cmd = path.commands[i];
        if (cmd.type === "M") {
            ctx.moveTo(cmd.x, cmd.y);
        } else if (cmd.type === "L") {
            ctx.lineTo(cmd.x, cmd.y);
            x1 = x2;
            y1 = y2;
        } else if (cmd.type === "C") {
            ctx.bezierCurveTo(cmd.x1, cmd.y1, cmd.x2, cmd.y2, cmd.x, cmd.y);
            x1 = cmd.x2;
            y1 = cmd.y2;
        } else if (cmd.type === "Q") {
            ctx.quadraticCurveTo(cmd.x1, cmd.y1, cmd.x, cmd.y);
            x1 = cmd.x1;
            y1 = cmd.y1;
        } else if (cmd.type === "Z") {
            ctx.closePath();
        }
        x2 = cmd.x;
        y2 = cmd.y;
    }
    if (path.fill) {
        ctx.fillStyle = path.fillStyle || getCssVariableValue("--white");
        ctx.fill();
    }
    if (path.stroke) {
        ctx.strokeStyle = path.strokeStyle || getCssVariableValue("--white");
        ctx.lineWidth = path.strokeWidth;
        ctx.stroke();
    }
};
var GlyphModalContent = function(param) {
    var glyphData1 = param.glyphData;
    var canvasRef = (0,react.useRef)(null);
    var canvasBgRef = (0,react.useRef)(null);
    var PIXEL_RATIO =  true && window.devicePixelRatio || 1;
    var CANVAS_HEIGHT = 450;
    var CANVAS_WIDTH = 650;
    var GLYPH_MARGIN = 10;
    var ref = glyphData1 || {}, script = ref.script, subCategory = ref.subCategory, char = ref.char;
    var renderGlyph = function(glyphData) {
        var canvas = canvasRef.current;
        var canvasCtx = canvas === null || canvas === void 0 ? void 0 : canvas.getContext("2d");
        var width = canvas.width / PIXEL_RATIO;
        var height = canvas.height / PIXEL_RATIO;
        canvasCtx.clearRect(0, 0, width, height);
        canvasCtx.textAlign = "center";
        canvasCtx.textBaseline = "middle";
        var path = glyphData.path;
        drawGlyphPath(canvasCtx, path);
    };
    var renderCanvas = function(glyphData) {
        var canvas = canvasBgRef.current; //canvasBg
        var canvasCtx = canvas === null || canvas === void 0 ? void 0 : canvas.getContext("2d"); //glyphBgCtx
        var canvasPixelRatio = PIXEL_RATIO;
        var canvasMargin = GLYPH_MARGIN;
        var canvasWidth = canvas.width;
        var canvasHeight = canvas.height;
        var canvasWidthComputed = canvasWidth / canvasPixelRatio; //w
        var canvasHeightComputed = canvasHeight / canvasPixelRatio; //h
        var glyphCanvasWidthComputed = canvasWidthComputed - canvasMargin * 2; //glyphW
        var glyphCanvasHeightComputed = canvasHeightComputed - canvasMargin * 2; //glyphH
        var glyphYMax = Math.max(glyphData.tables.head.yMax, glyphData.tables.os2.sTypoAscender);
        var glyphYMin = Math.min(glyphData.tables.head.yMin, glyphData.tables.os2.sTypoDescender);
        var glyphMaxWidth = glyphData.advanceWidth; //maxWidth
        var glyphMaxHeight = glyphYMax - glyphYMin; //maxHeight
        canvasCtx.clearRect(0, 0, canvasWidthComputed, canvasHeightComputed);
        canvasCtx.fillStyle = getCssVariableValue("--grey-primary");
        canvasCtx.font = "".concat(14 * (canvasWidth / canvasHeight), "px Basis-Grotesque-Mono-Pro");
        var scale = Math.min(glyphCanvasWidthComputed / glyphMaxWidth, glyphCanvasHeightComputed / glyphMaxHeight);
        var baseline = canvasMargin + glyphYMax * scale;
        var descenderValue = glyphData.controlBoundingBox.y1 < 0 ? glyphData.controlBoundingBox.y1 : glyphData.tables.os2.sTypoDescender;
        var descender = baseline - descenderValue * scale;
        var xheight = baseline - glyphData.tables.os2.sxHeight * scale;
        var capheight = baseline - glyphData.tables.os2.sCapHeight * scale;
        var drawHLine = hline(canvasCtx, canvasWidthComputed);
        drawHLine(capheight, {
            text: "1",
            top: true,
            dashed: false
        });
        drawHLine(xheight, {
            text: "2",
            top: true,
            dashed: true
        });
        drawHLine(baseline, {
            text: "3",
            top: true,
            dashed: false
        });
        drawHLine(descender, {
            text: "4",
            top: true,
            dashed: true
        });
        renderGlyph(glyphData);
    };
    (0,react.useEffect)(function() {
        enableHighDPICanvas(canvasRef === null || canvasRef === void 0 ? void 0 : canvasRef.current, PIXEL_RATIO);
        enableHighDPICanvas(canvasBgRef === null || canvasBgRef === void 0 ? void 0 : canvasBgRef.current, PIXEL_RATIO);
        if (glyphData1) renderCanvas(glyphData1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        glyphData1
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (PanelGlyphs_module_default()).modal,
        children: [
            !glyphData1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* Spinner */.$, {
                theme: "white",
                contextual: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (PanelGlyphs_module_default()).modal__Left,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                script ? "".concat(script, " ") : "",
                                subCategory ? "".concat(subCategory) : "",
                                "\xa0",
                                (0,util/* entitify */.od)(char)
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                        className: (PanelGlyphs_module_default()).modal__LeftEntities,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: "Unicode DECIMAL"
                                    }),
                                    hexToDecimal(char)
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: "Unicode HEX"
                                    }),
                                    char
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: "HTML Entity (Hex)"
                                    }),
                                    htmlEntity(char)
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: "HTML Code"
                                    }),
                                    htmlCode(char)
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: "CSS Code"
                                    }),
                                    "\\".concat(char)
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                        className: (PanelGlyphs_module_default()).modal__LeftEntities,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: "1"
                                    }),
                                    "Cap Height"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: "2"
                                    }),
                                    "X-Height"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: "3"
                                    }),
                                    "Baseline"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: "4"
                                    }),
                                    "Descender"
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (PanelGlyphs_module_default()).modal__Right,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                        children: "U+".concat(char)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (PanelGlyphs_module_default()).canvasContainer,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("canvas", {
                                ref: canvasRef,
                                id: "glyph",
                                className: (PanelGlyphs_module_default()).modalGlyph,
                                width: CANVAS_WIDTH,
                                height: CANVAS_HEIGHT
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("canvas", {
                                ref: canvasBgRef,
                                id: "glyphBg",
                                className: (PanelGlyphs_module_default()).modalGlyphBg,
                                width: CANVAS_WIDTH,
                                height: CANVAS_HEIGHT
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var PanelGlyphs_GlyphModalContent = (GlyphModalContent);

// EXTERNAL MODULE: ./lib/aws/client.ts
var client = __webpack_require__(14353);
// EXTERNAL MODULE: ./lib/hooks/mediaQuery.ts
var mediaQuery = __webpack_require__(99182);
// EXTERNAL MODULE: ./components/global/FontLoader/index.tsx
var FontLoader = __webpack_require__(53409);
// EXTERNAL MODULE: ./components/global/PanelFont/helpers.ts
var helpers = __webpack_require__(60476);
;// CONCATENATED MODULE: ./components/global/PanelFont/PanelGlyphs/PanelGlyphs.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}















function createStyles(fontName) {
    return {
        __html: "\n    :root {\n      --".concat(fontName, ": '").concat(fontName, "';\n    }\n  ")
    };
}
var PanelGlyphs = function(param) {
    var fontStyleVersionActive = param.fontStyleVersionActive, childrenHeader = param.childrenHeader, fontStyleVersionChars = param.fontStyleVersionChars, fontSizeAdjust = param.fontSizeAdjust, childrenContent = param.childrenContent, childrenFooter = param.childrenFooter;
    var screen = (0,mediaQuery/* useScreenSize */.e)();
    var isMobile = screen === "Mobile";
    var ref4 = (0,react.useState)(false), glyphModalOpen = ref4[0], setGlyphModalOpen = ref4[1];
    var ref1 = (0,react.useState)(null), modalButtonLabel = ref1[0], setModalButtonLabel = ref1[1];
    var ref2 = (0,react.useState)(null), glyphData1 = ref2[0], setGlyphData = ref2[1];
    var ref3 = (0,react.useState)({}), glyphDataCache = ref3[0], setGlyphDataCache = ref3[1];
    var fontToLoad = fontStyleVersionActive && (0,util/* updateFontsToWebfont */.cw)({
        font: fontStyleVersionActive.fondue.meta.path
    });
    var fetchGlyphData = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(char, script, subCategory) {
            var glyph, glyphButtonLabel, path, product, sku, fontFamily, fontStyle, ref, _pathWithoutExtension, pathExtension, version, glyphData, glyphDataUrl, glyphDataRes;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        glyph = char;
                        glyphButtonLabel = /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (PanelGlyphs_module_default()).glyphChar__Entity,
                                    children: "U+".concat(char)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (PanelGlyphs_module_default()).glyphChar__Char,
                                    children: (0,util/* entitify */.od)(char)
                                })
                            ]
                        });
                        path = fontStyleVersionActive.fondue.meta.path;
                        product = fontStyleVersionActive.product, sku = fontStyleVersionActive.sku;
                        fontFamily = product.slug.toLowerCase();
                        fontStyle = sku.replace(/-pro$/, "");
                        ref = _slicedToArray(path.split("."), 2), _pathWithoutExtension = ref[0], pathExtension = ref[1];
                        version = fontStyleVersionActive.sku.match(/-pro$/) ? "pro" : "std";
                        glyphData = null;
                        setGlyphData(null);
                        setGlyphModalOpen(true);
                        if (!glyphDataCache["".concat(sku, "-").concat(char)]) {
                            _ctx.next = 15;
                            break;
                        }
                        {
                            glyphData = glyphDataCache["".concat(sku, "-").concat(char)];
                        }
                        _ctx.next = 21;
                        break;
                    case 15:
                        glyphDataUrl = "".concat(fontFamily, "/").concat(fontStyle, "/glyphs/").concat(glyph);
                        _ctx.next = 18;
                        return client/* AWSClient.fontGlyphsData */.k.fontGlyphsData("get", {
                            params: {
                                version: version,
                                extension: pathExtension
                            },
                            pathAppend: glyphDataUrl
                        });
                    case 18:
                        glyphDataRes = _ctx.sent;
                        glyphData = glyphDataRes;
                        setGlyphDataCache(_objectSpread({}, glyphDataCache, _defineProperty({}, "".concat(sku, "-").concat(char), glyphData)));
                    case 21:
                        setModalButtonLabel(glyphButtonLabel);
                        setGlyphData(_objectSpread({}, glyphData, {
                            char: char,
                            script: script,
                            subCategory: subCategory
                        }));
                    case 23:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function fetchGlyphData(char, script, subCategory) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (PanelGlyphs_module_default()).PanelGlyphs,
        style: _objectSpread({}, fontSizeAdjust && {
            "--glyph-size-adjust": fontSizeAdjust
        }),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.ZP, _objectSpread({
                splitModal: true,
                controlled: true,
                controlledOpen: glyphModalOpen,
                controlledSetOpen: setGlyphModalOpen,
                ModalButtonLabel: modalButtonLabel
            }, !isMobile && {
                closeButtonColor: "var(--white)"
            }, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PanelGlyphs_GlyphModalContent, {
                    glyphData: glyphData1
                })
            })),
            fontStyleVersionActive && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("style", {
                        dangerouslySetInnerHTML: createStyles(fontStyleVersionActive.fondue.slug)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FontLoader/* default */.Z, {
                        s3Path: fontToLoad,
                        fontName: fontStyleVersionActive.fondue.slug,
                        fullPath: !fontToLoad.includes("https://")
                    })
                ]
            }, fontStyleVersionActive.fondue.meta.src),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Panel/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PanelHeader/* default */.Z, {
                        children: childrenHeader
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(PanelContent/* default */.Z, {
                        children: [
                            childrenContent ? childrenContent : fontStyleVersionChars === null || fontStyleVersionChars === void 0 ? void 0 : fontStyleVersionChars.map(function(character, index) {
                                var chars = character.chars, script = character.script, category = character.category, subCategory = character.subCategory;
                                var categoryLabel = (0,helpers/* getTranslatedCategoryLabel */.ZL)(category, subCategory);
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                                    className: (PanelGlyphs_module_default()).PanelGlyphs__section,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
                                            className: (PanelGlyphs_module_default()).PanelGlyphs__sectionHeader,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                className: (PanelGlyphs_module_default()).PanelGlyphs__sectionHeaderTitle,
                                                children: categoryLabel
                                            })
                                        }),
                                        chars.map(function(char) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(GlyphsCharacter/* default */.Z, {
                                                char: char,
                                                entity: "U+".concat(char),
                                                script: script,
                                                subCategory: subCategory,
                                                glyphSheetName: fontStyleVersionActive.fondue.slug,
                                                handler: fetchGlyphData,
                                                as: "button",
                                                children: (0,util/* entitify */.od)(char)
                                            }, char);
                                        })
                                    ]
                                }, "".concat(character.category, "-").concat(subCategory, "-").concat(index));
                            }),
                            childrenFooter && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: childrenFooter
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var PanelGlyphs_PanelGlyphs = (PanelGlyphs);

;// CONCATENATED MODULE: ./components/global/PanelFont/PanelGlyphs/index.ts



/***/ }),

/***/ 60476:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "fm": function() { return /* binding */ capitalizeFirstLetter; },
/* harmony export */   "wQ": function() { return /* binding */ mapVariableFontAxesToKeyAndDefaultValue; },
/* harmony export */   "_N": function() { return /* binding */ getVariableFontAxesActiveRange; },
/* harmony export */   "qb": function() { return /* binding */ getVariableFontAxesStyle; },
/* harmony export */   "FT": function() { return /* binding */ getTextSectionStyle; },
/* harmony export */   "oo": function() { return /* binding */ hexToRgb; },
/* harmony export */   "a2": function() { return /* binding */ hex3ToHex6; },
/* harmony export */   "ZL": function() { return /* binding */ getTranslatedCategoryLabel; }
/* harmony export */ });
/* unused harmony export GLYPH_SECTION_LABELS */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85170);
/* harmony import */ var _lib_util__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70108);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}


var capitalizeFirstLetter = function(string) {
    var input = string.replace(/\W/g, "");
    return input.charAt(0).toUpperCase() + input.slice(1);
};
var mapVariableFontAxesToKeyAndDefaultValue = function(fontAxes) {
    var fontAxesKeyAndValue = fontAxes.reduce(function(acc, fontAxe) {
        return _objectSpread({}, acc, _defineProperty({}, fontAxe.id, fontAxe.default));
    }, {});
    return fontAxesKeyAndValue;
};
var getVariableFontAxesActiveRange = function(fontAxes) {
    var range = Math.abs(fontAxes.max) - Math.abs(fontAxes.min);
    if (range <= 1) return 0.1;
    if (range % 1 > 0) return (0,_lib_util__WEBPACK_IMPORTED_MODULE_1__/* .round */ .NM)(range % 1, 1);
    return 1;
};
var getVariableFontAxesStyle = function(fontVariationSettings) {
    return "".concat(Object.keys(fontVariationSettings).map(function(fontVariationSetting) {
        return '"'.concat(fontVariationSetting, '" ').concat(Array.isArray(fontVariationSettings[fontVariationSetting]) ? fontVariationSettings[fontVariationSetting][1] : fontVariationSettings[fontVariationSetting]);
    }).join(", "));
};
var getTextSectionStyle = function(param) {
    var fontFamily = param.fontFamily, fontSize = param.fontSize, textAlign = param.textAlign, fontVariationSettings = param.fontVariationSettings, fontVariable = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return fontVariable && fontVariationSettings ? {
        fontFamily: fontFamily,
        fontSize: fontSize,
        textAlign: textAlign,
        fontVariationSettings: getVariableFontAxesStyle(fontVariationSettings)
    } : {
        fontFamily: fontFamily,
        fontSize: fontSize,
        textAlign: textAlign
    };
};
// ref: https://convertingcolors.com/blog/article/convert_hex_to_rgb_with_javascript.html
var hexToRgb = function(hexcode) {
    var aRgbHex = hexcode.replace("#", "").match(/.{1,2}/g);
    var aRgb = [
        parseInt(aRgbHex[0], 16),
        parseInt(aRgbHex[1], 16),
        parseInt(aRgbHex[2], 16)
    ];
    return aRgb.join(", ");
};
// ref: https://gomakethings.com/converting-a-color-from-a-three-digit-hexcolor-to-a-six-digit-hexcolor-with-vanilla-js/
var hex3ToHex6 = function(hexcode) {
    var hex3 = hexcode.replace("#", "");
    if (hex3.length !== 3) return hexcode;
    var hex6 = hex3.split("").reduce(function(acc, char) {
        return "".concat(acc).concat(char).concat(char);
    }, "");
    return "#".concat(hex6);
};
var GLYPH_SECTION_LABELS = {
    letter: "Letters",
    number: "Numerals",
    letterUppercase: "Uppercase Letters",
    letterLowercase: "Lowercase Letters",
    letterSuperscript: "Superscript Forms",
    letterLigature: "Ligatures",
    numberDecimalDigit: "Digit Numerals",
    numberSmall: "Numeral Derivatives",
    numberFraction: "Fractions",
    punctuation: "Punctuation",
    punctuationQuote: "Quotation Marks",
    punctuationParenthesis: "Parenthesis",
    punctuationDash: "Dashes",
    symbol: "Symbols",
    symbolCurrency: "Currency Symbols",
    symbolMath: "Math Symbols",
    symbolArrow: "Arrows",
    symbolGeometry: "Geometric Symbols",
    separator: "Seperators",
    separatorSpace: "Seperator Spaces",
    separatorFormat: "Formatting Seperators",
    separatorNonspace: "Nonspacing Seperators",
    markModifier: "Marks",
    markSpacing: "Accent Marks",
    markNonspacing: "Combining Accent Marks",
    uncategorised: "Miscellaneous"
};
var getTranslatedCategoryLabel = function(category, subCategory) {
    var categoryLabel = "".concat(category).concat(subCategory ? "-".concat(subCategory) : "");
    var translatedCategoryLabel = (GLYPH_SECTION_LABELS === null || GLYPH_SECTION_LABELS === void 0 ? void 0 : GLYPH_SECTION_LABELS[(0,_lib_util__WEBPACK_IMPORTED_MODULE_1__/* .convertSnakeToCamelCase */ .Vx)(categoryLabel.replace(" ", "-").toLowerCase())]) || categoryLabel;
    return translatedCategoryLabel;
};


/***/ }),

/***/ 86654:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"glyphChar":"GlyphsCharacter_glyphChar__5g0Cc","glyphChar__Entity":"GlyphsCharacter_glyphChar__Entity__ftJ4M","glyphChar__Char":"GlyphsCharacter_glyphChar__Char__nG78f","hoverEffect":"GlyphsCharacter_hoverEffect__6xSui"};

/***/ }),

/***/ 2245:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"PanelGlyphs":"PanelGlyphs_PanelGlyphs__P2YKk","PanelGlyphs__section":"PanelGlyphs_PanelGlyphs__section__YHmoH","PanelGlyphs__sectionHeader":"PanelGlyphs_PanelGlyphs__sectionHeader__Pv4uv","PanelGlyphs__sectionHeaderTitle":"PanelGlyphs_PanelGlyphs__sectionHeaderTitle__C_IJ_","modal":"PanelGlyphs_modal__BxT9Q","modal__Left":"PanelGlyphs_modal__Left__qeulh","modal__LeftEntities":"PanelGlyphs_modal__LeftEntities__wr9gg","modal__Right":"PanelGlyphs_modal__Right__Wz5Pa","modal__RightCharacter":"PanelGlyphs_modal__RightCharacter__N9fOb","canvasContainer":"PanelGlyphs_canvasContainer__eV_Pq","modalGlyph":"PanelGlyphs_modalGlyph__5tBT3","modalGlyphBg":"PanelGlyphs_modalGlyphBg__RLj6s"};

/***/ })

}]);